if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return; 

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    checkIfOptionSelected(radios) {
      let checked = false;

      for (const radio of radios) {
        if (radio.checked) {
          checked = true;
          return;
        }
      }

      return checked;
    }

    connectedCallback() {
      const atc_button = this.querySelector('[data-atc-submit]');
      const atc_cta = atc_button.querySelector('[data-atc-cta]');
      const atc_message = document.querySelector('[data-atc-message]');
      const data_size_selector = document.querySelector('[data-size-selector]');
      const radios = data_size_selector.querySelectorAll('input[type="radio"]');
      const size_radio_labels = data_size_selector.querySelectorAll('[data-size-label]');
      const data_color_selector = document.querySelector('[data-color-selector]');
      const color_radios = data_color_selector.querySelectorAll('input[type="radio"]');
      let checked = this.checkIfOptionSelected(radios);

      atc_button.addEventListener('click', (ev) => {
        if (checked) return
        ev.preventDefault();

        atc_message.classList.remove('hidden');
        atc_message.removeAttribute('aria-hidden');

        // mark radios invalid and focus first
        radios.forEach(r => r.setAttribute('aria-invalid', 'true'));
        const firstEnabled = Array.from(radios).find(r => !r.disabled);
        if (firstEnabled) firstEnabled.focus();

        size_radio_labels.forEach((label) => {
          label.classList.remove('tw-border-paka-grey');
          label.classList.add('sp-border-red-600');
        })
      })

      if (!checked) {
        atc_cta.innerHTML = 'Select a size';

        color_radios.forEach(radio => {
          radio.addEventListener('change', () => {
            if (checked) return
            if (!atc_message.classList.contains('hidden')) {
              atc_message.classList.add('hidden');
              atc_message.setAttribute('aria-hidden', 'true');
              radios.forEach(r => r.removeAttribute('aria-invalid'));
              size_radio_labels.forEach((label) => {
                label.classList.remove('sp-border-red-600');
                label.classList.add('tw-border-paka-grey');
              })
            }
          })
        })

        radios.forEach(radio => {
          radio.addEventListener('change', () => {
            if (checked) return
            checked = true;
            atc_cta.innerHTML = 'Add to cart'
            atc_message.classList.add('hidden');
            atc_message.setAttribute('aria-hidden', 'true');
            radios.forEach(r => r.removeAttribute('aria-invalid'));
            size_radio_labels.forEach((label) => {
              label.classList.remove('sp-border-red-600');
              label.classList.add('tw-border-paka-grey');
            })
          })
        })
      }
    }

  });
}
